import { privateApi } from "@core/libs/axios/apiInstances";
import { handleMappedResponse } from "@core/libs/axios/serviceHandler";
import { WorkspaceSchema } from "@core/types";
import type { TWorkspace } from "@core/types";
import { createLogger } from "@core/utils/logger";

const log = createLogger("workspace:service");

const mapWorkspace = (raw: TWorkspace): TWorkspace => {
  const parsed = WorkspaceSchema.safeParse(raw);
  if (!parsed.success) {
    log.zod(parsed.error.issues, "mapWorkspace");
    throw {
      success: false,
      message: "Response validation failed",
      error: {
        code: "PARSE_ERROR",
        message: "Workspace response did not match expected shape",
        details: parsed.error.issues,
      },
      data: null,
    };
  }
  return parsed.data;
};

type MemberWorkspaceResponse = {
  workspace: Record<string, unknown>;
  admin_email: string | null;
};

export const getWorkspace = async (
  workspaceId: string,
  signal?: AbortSignal,
): Promise<TWorkspace> => {
  return handleMappedResponse(
    privateApi.get(`/workspace/${workspaceId}`, { signal }),
    WorkspaceSchema,
    mapWorkspace,
  );
};

export const getWorkspaceForMembers = async (
  workspaceId: string,
  signal?: AbortSignal,
): Promise<TWorkspace> => {
  const result = await privateApi.get<MemberWorkspaceResponse>(
    `/projects/workspace/${workspaceId}/`,
    { signal },
  );
  const raw = { ...result.data.workspace, admin_email: result.data.admin_email };
  return mapWorkspace(raw as TWorkspace);
};
